import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BackButton } from "@/components/ui/back-button";
import { useLanguage } from "@/hooks/use-language";
import { getTranslation } from "@/lib/translations";

export default function PrivacyPolicyPage() {
  const { language } = useLanguage();

  const privacyContent = {
    pl: (
      <>
        <h2>1. Informacje ogólne</h2>
        <p>
          Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych przekazanych przez Użytkowników w związku z korzystaniem z usług oferowanych przez firmę <span className="logo-gradient font-medium">1Group</span> z siedzibą w Poznaniu przy ul. Stary Rynek 61/2.
        </p>
        <p>
          Administratorem danych osobowych jest <span className="logo-gradient font-medium">1Group</span> (dalej jako "Administrator"), który dokłada wszelkich starań, aby dane były przetwarzane zgodnie z obowiązującymi przepisami prawa, w szczególności z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych (RODO).
        </p>
        
        <h2>2. Cel i zakres zbierania danych</h2>
        <p>
          Przetwarzamy dane osobowe w następujących celach:
        </p>
        <ul>
          <li>Realizacji usług świadczonych przez <span className="logo-gradient font-medium">1Group</span>, w tym rejestracji spółek, obsługi księgowej, legalizacji pobytu, rejestracji pojazdów;</li>
          <li>Komunikacji z klientami w sprawach związanych ze świadczonymi usługami;</li>
          <li>Marketingu własnych usług;</li>
          <li>Realizacji obowiązków prawnych ciążących na Administratorze;</li>
          <li>Dochodzenia roszczeń związanych z zawartą umową.</li>
        </ul>
        <p>
          Zakres przetwarzanych danych obejmuje:
        </p>
        <ul>
          <li>Dane identyfikacyjne (imię, nazwisko, PESEL, NIP);</li>
          <li>Dane kontaktowe (adres e-mail, numer telefonu, adres korespondencyjny);</li>
          <li>Dane niezbędne do realizacji poszczególnych usług (np. dane pojazdu przy rejestracji, dane do dokumentów przy legalizacji pobytu).</li>
        </ul>
        
        <h2>3. Podstawa prawna przetwarzania danych</h2>
        <p>
          Dane osobowe są przetwarzane na podstawie:
        </p>
        <ul>
          <li>Niezbędności do wykonania umowy lub podjęcia działań przed zawarciem umowy (art. 6 ust. 1 lit. b RODO);</li>
          <li>Obowiązku prawnego ciążącego na Administratorze (art. 6 ust. 1 lit. c RODO);</li>
          <li>Prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO);</li>
          <li>Zgody osoby, której dane dotyczą (art. 6 ust. 1 lit. a RODO).</li>
        </ul>
        
        <h2>4. Okres przechowywania danych</h2>
        <p>
          Dane osobowe przechowujemy przez okres:
        </p>
        <ul>
          <li>Niezbędny do realizacji usługi oraz przez czas wymagany przepisami prawa (np. przepisy podatkowe, rachunkowe);</li>
          <li>Do momentu przedawnienia roszczeń wynikających z zawartej umowy;</li>
          <li>Do momentu wycofania zgody, jeśli przetwarzanie odbywa się na jej podstawie.</li>
        </ul>
        
        <h2>5. Odbiorcy danych</h2>
        <p>
          Odbiorcami danych osobowych mogą być:
        </p>
        <ul>
          <li>Podmioty przetwarzające dane w imieniu Administratora (np. dostawcy usług IT, biura rachunkowe);</li>
          <li>Podmioty uprawnione do uzyskania danych na podstawie obowiązującego prawa (np. sądy, organy ścigania);</li>
          <li>Urzędy i instytucje państwowe niezbędne do realizacji usług (np. urzędy miasta, urzędy skarbowe).</li>
        </ul>
        
        <h2>6. Prawa osób, których dane dotyczą</h2>
        <p>
          Osobom, których dane dotyczą, przysługują następujące prawa:
        </p>
        <ul>
          <li>Prawo dostępu do swoich danych oraz otrzymania ich kopii;</li>
          <li>Prawo do sprostowania (poprawiania) swoich danych;</li>
          <li>Prawo do usunięcia danych (tzw. "prawo do bycia zapomnianym");</li>
          <li>Prawo do ograniczenia przetwarzania danych;</li>
          <li>Prawo do przenoszenia danych;</li>
          <li>Prawo do wniesienia sprzeciwu wobec przetwarzania;</li>
          <li>Prawo do cofnięcia zgody w dowolnym momencie (bez wpływu na zgodność z prawem przetwarzania dokonanego przed cofnięciem zgody);</li>
          <li>Prawo do wniesienia skargi do organu nadzorczego (Prezes Urzędu Ochrony Danych Osobowych).</li>
        </ul>
        
        <h2>7. Zabezpieczenie danych</h2>
        <p>
          Administrator stosuje odpowiednie środki techniczne i organizacyjne zapewniające bezpieczeństwo przetwarzanych danych osobowych, w szczególności zabezpieczające dane przed ich udostępnieniem osobom nieupoważnionym, zabraniem przez osobę nieuprawnioną, utratą, uszkodzeniem lub zniszczeniem.
        </p>
        
        <h2>8. Cookies</h2>
        <p>
          Nasza strona internetowa wykorzystuje pliki cookies (ciasteczka), które służą identyfikacji przeglądarki podczas korzystania z naszej strony. Cookies zawierają niewielkie ilości tekstu i nie zawierają danych osobowych. Mogą być one usunięte w każdej chwili za pomocą ustawień przeglądarki.
        </p>
        
        <h2>9. Zmiany Polityki Prywatności</h2>
        <p>
          Administrator zastrzega sobie prawo do zmiany Polityki Prywatności. O wszelkich zmianach użytkownicy będą informowani poprzez publikację zaktualizowanej wersji na stronie internetowej.
        </p>
        
        <h2>10. Kontakt</h2>
        <p>
          We wszelkich sprawach związanych z przetwarzaniem danych osobowych, w tym w celu realizacji praw, o których mowa w punkcie 6, prosimy o kontakt:
        </p>
        <ul>
          <li>Email: kontakt1group.pl@gmail.com</li>
          <li>Telefon: +48 886 695 593</li>
          <li>Adres: ul. Stary Rynek 61/2, 61-772 Poznań</li>
        </ul>
      </>
    ),

    en: (
      <>
        <h2>1. General Information</h2>
        <p>
          This Privacy Policy defines the rules for processing and protecting personal data provided by Users in connection with using the services offered by <span className="logo-gradient font-medium">1Group</span> based in Poznań at ul. Stary Rynek 61/2.
        </p>
        <p>
          The administrator of personal data is <span className="logo-gradient font-medium">1Group</span> (hereinafter referred to as the "Administrator"), which makes every effort to ensure that data is processed in accordance with applicable law, in particular with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data (GDPR).
        </p>
        
        <h2>2. Purpose and Scope of Data Collection</h2>
        <p>
          We process personal data for the following purposes:
        </p>
        <ul>
          <li>Implementation of services provided by <span className="logo-gradient font-medium">1Group</span>, including company registration, accounting services, residence legalization, vehicle registration;</li>
          <li>Communication with customers on matters related to the services provided;</li>
          <li>Marketing of own services;</li>
          <li>Fulfillment of legal obligations incumbent on the Administrator;</li>
          <li>Pursuit of claims related to the concluded agreement.</li>
        </ul>
        <p>
          The scope of processed data includes:
        </p>
        <ul>
          <li>Identification data (first name, last name, PESEL, NIP);</li>
          <li>Contact details (e-mail address, phone number, correspondence address);</li>
          <li>Data necessary for the implementation of individual services (e.g., vehicle data during registration, document data for residence legalization).</li>
        </ul>
        
        <h2>3. Legal Basis for Data Processing</h2>
        <p>
          Personal data is processed on the basis of:
        </p>
        <ul>
          <li>Necessity for the performance of a contract or taking steps prior to entering into a contract (Article 6(1)(b) GDPR);</li>
          <li>Legal obligation incumbent on the Administrator (Article 6(1)(c) GDPR);</li>
          <li>Legitimate interest of the Administrator (Article 6(1)(f) GDPR);</li>
          <li>Consent of the data subject (Article 6(1)(a) GDPR).</li>
        </ul>
        
        <h2>4. Data Storage Period</h2>
        <p>
          We store personal data for the period:
        </p>
        <ul>
          <li>Necessary for the implementation of the service and for the time required by law (e.g., tax and accounting regulations);</li>
          <li>Until the expiry of claims arising from the concluded agreement;</li>
          <li>Until the withdrawal of consent, if processing is based on it.</li>
        </ul>
        
        <h2>5. Data Recipients</h2>
        <p>
          Recipients of personal data may be:
        </p>
        <ul>
          <li>Entities processing data on behalf of the Administrator (e.g., IT service providers, accounting offices);</li>
          <li>Entities entitled to obtain data based on applicable law (e.g., courts, law enforcement authorities);</li>
          <li>Government offices and institutions necessary for the implementation of services (e.g., city offices, tax offices).</li>
        </ul>
        
        <h2>6. Rights of Data Subjects</h2>
        <p>
          Data subjects have the following rights:
        </p>
        <ul>
          <li>Right of access to their data and to receive a copy of it;</li>
          <li>Right to rectify (correct) their data;</li>
          <li>Right to erasure of data (the so-called "right to be forgotten");</li>
          <li>Right to restriction of processing;</li>
          <li>Right to data portability;</li>
          <li>Right to object to processing;</li>
          <li>Right to withdraw consent at any time (without affecting the lawfulness of processing based on consent before its withdrawal);</li>
          <li>Right to lodge a complaint with a supervisory authority (President of the Personal Data Protection Office).</li>
        </ul>
        
        <h2>7. Data Security</h2>
        <p>
          The Administrator applies appropriate technical and organizational measures ensuring the security of processed personal data, in particular protecting data against unauthorized disclosure, taking by an unauthorized person, loss, damage or destruction.
        </p>
        
        <h2>8. Cookies</h2>
        <p>
          Our website uses cookies, which are used to identify the browser when using our website. Cookies contain small amounts of text and do not contain personal data. They can be deleted at any time using browser settings.
        </p>
        
        <h2>9. Changes to the Privacy Policy</h2>
        <p>
          The Administrator reserves the right to change the Privacy Policy. Users will be informed of any changes through the publication of an updated version on the website.
        </p>
        
        <h2>10. Contact</h2>
        <p>
          For all matters related to the processing of personal data, including for the purpose of exercising the rights referred to in point 6, please contact:
        </p>
        <ul>
          <li>Email: kontakt1group.pl@gmail.com</li>
          <li>Phone: +48 886 695 593</li>
          <li>Address: ul. Stary Rynek 61/2, 61-772 Poznań</li>
        </ul>
      </>
    ),

    uk: (
      <>
        <h2>1. Загальна інформація</h2>
        <p>
          Ця Політика конфіденційності визначає правила обробки та захисту персональних даних, наданих Користувачами у зв'язку з використанням послуг, що пропонуються компанією <span className="logo-gradient font-medium">1Group</span> з місцезнаходженням у Познані за адресою вул. Стари Ринек 61/2.
        </p>
        <p>
          Адміністратором персональних даних є <span className="logo-gradient font-medium">1Group</span> (далі - "Адміністратор"), який докладає всіх зусиль для забезпечення обробки даних відповідно до чинного законодавства, зокрема Регламенту Європейського Парламенту і Ради (ЄС) 2016/679 від 27 квітня 2016 року про захист фізичних осіб щодо обробки персональних даних (GDPR).
        </p>
        
        <h2>2. Мета та обсяг збору даних</h2>
        <p>
          Ми обробляємо персональні дані для таких цілей:
        </p>
        <ul>
          <li>Реалізація послуг, що надаються <span className="logo-gradient font-medium">1Group</span>, включаючи реєстрацію компаній, бухгалтерські послуги, легалізацію перебування, реєстрацію транспортних засобів;</li>
          <li>Комунікація з клієнтами з питань, пов'язаних з наданими послугами;</li>
          <li>Маркетинг власних послуг;</li>
          <li>Виконання юридичних зобов'язань Адміністратора;</li>
          <li>Переслідування претензій, пов'язаних з укладеною угодою.</li>
        </ul>
        <p>
          Обсяг оброблюваних даних включає:
        </p>
        <ul>
          <li>Ідентифікаційні дані (ім'я, прізвище, PESEL, NIP);</li>
          <li>Контактні дані (електронна адреса, номер телефону, поштова адреса);</li>
          <li>Дані, необхідні для реалізації окремих послуг (наприклад, дані транспортного засобу під час реєстрації, дані документів для легалізації перебування).</li>
        </ul>
        
        <h2>3. Правова основа обробки даних</h2>
        <p>
          Персональні дані обробляються на підставі:
        </p>
        <ul>
          <li>Необхідності для виконання договору або вжиття заходів перед укладенням договору (стаття 6(1)(b) GDPR);</li>
          <li>Юридичного зобов'язання Адміністратора (стаття 6(1)(c) GDPR);</li>
          <li>Законного інтересу Адміністратора (стаття 6(1)(f) GDPR);</li>
          <li>Згоди суб'єкта даних (стаття 6(1)(a) GDPR).</li>
        </ul>
        
        <h2>4. Період зберігання даних</h2>
        <p>
          Ми зберігаємо персональні дані протягом періоду:
        </p>
        <ul>
          <li>Необхідного для реалізації послуги та протягом часу, передбаченого законодавством (наприклад, податкові та бухгалтерські правила);</li>
          <li>До закінчення строку давності претензій, що випливають з укладеної угоди;</li>
          <li>До відкликання згоди, якщо обробка базується на ній.</li>
        </ul>
        
        <h2>5. Одержувачі даних</h2>
        <p>
          Одержувачами персональних даних можуть бути:
        </p>
        <ul>
          <li>Суб'єкти, що обробляють дані від імені Адміністратора (наприклад, постачальники ІТ-послуг, бухгалтерські офіси);</li>
          <li>Суб'єкти, уповноважені отримувати дані на підставі чинного законодавства (наприклад, суди, правоохоронні органи);</li>
          <li>Державні установи та інституції, необхідні для реалізації послуг (наприклад, міські офіси, податкові офіси).</li>
        </ul>
        
        <h2>6. Права суб'єктів даних</h2>
        <p>
          Суб'єкти даних мають такі права:
        </p>
        <ul>
          <li>Право доступу до своїх даних та отримання їх копії;</li>
          <li>Право на виправлення (коригування) своїх даних;</li>
          <li>Право на видалення даних (так зване "право бути забутим");</li>
          <li>Право на обмеження обробки даних;</li>
          <li>Право на перенесення даних;</li>
          <li>Право на заперечення проти обробки;</li>
          <li>Право відкликати згоду в будь-який момент (без впливу на законність обробки, здійсненої на підставі згоди до її відкликання);</li>
          <li>Право подати скаргу до наглядового органу (Голова Управління захисту персональних даних).</li>
        </ul>
        
        <h2>7. Безпека даних</h2>
        <p>
          Адміністратор застосовує відповідні технічні та організаційні заходи, що забезпечують безпеку оброблюваних персональних даних, зокрема захищають дані від несанкціонованого розкриття, захоплення неуповноваженою особою, втрати, пошкодження або знищення.
        </p>
        
        <h2>8. Cookies</h2>
        <p>
          Наш веб-сайт використовує файли cookies, які служать для ідентифікації браузера під час використання нашого сайту. Cookies містять невеликі обсяги тексту і не містять персональних даних. Вони можуть бути видалені в будь-який момент за допомогою налаштувань браузера.
        </p>
        
        <h2>9. Зміни Політики конфіденційності</h2>
        <p>
          Адміністратор залишає за собою право змінювати Політику конфіденційності. Користувачі будуть повідомлені про будь-які зміни через публікацію оновленої версії на веб-сайті.
        </p>
        
        <h2>10. Контакт</h2>
        <p>
          З усіх питань, пов'язаних з обробкою персональних даних, у тому числі для реалізації прав, зазначених у пункті 6, просимо звертатися:
        </p>
        <ul>
          <li>Email: kontakt1group.pl@gmail.com</li>
          <li>Телефон: +48 886 695 593</li>
          <li>Адреса: вул. Стари Ринек 61/2, 61-772 Познань</li>
        </ul>
      </>
    ),

    ru: (
      <>
        <h2>1. Общая информация</h2>
        <p>
          Настоящая Политика конфиденциальности определяет правила обработки и защиты персональных данных, предоставленных Пользователями в связи с использованием услуг, предлагаемых компанией <span className="logo-gradient font-medium">1Group</span> с местонахождением в Познани по адресу ул. Стары Рынек 61/2.
        </p>
        <p>
          Администратором персональных данных является <span className="logo-gradient font-medium">1Group</span> (далее - "Администратор"), который прилагает все усилия для обеспечения обработки данных в соответствии с действующим законодательством, в частности с Регламентом Европейского Парламента и Совета (ЕС) 2016/679 от 27 апреля 2016 года о защите физических лиц в отношении обработки персональных данных (GDPR).
        </p>
        
        <h2>2. Цель и объем сбора данных</h2>
        <p>
          Мы обрабатываем персональные данные для следующих целей:
        </p>
        <ul>
          <li>Реализация услуг, предоставляемых <span className="logo-gradient font-medium">1Group</span>, включая регистрацию компаний, бухгалтерские услуги, легализацию пребывания, регистрацию транспортных средств;</li>
          <li>Коммуникация с клиентами по вопросам, связанным с предоставляемыми услугами;</li>
          <li>Маркетинг собственных услуг;</li>
          <li>Выполнение юридических обязательств Администратора;</li>
          <li>Преследование претензий, связанных с заключенным соглашением.</li>
        </ul>
        <p>
          Объем обрабатываемых данных включает:
        </p>
        <ul>
          <li>Идентификационные данные (имя, фамилия, PESEL, NIP);</li>
          <li>Контактные данные (электронная почта, номер телефона, почтовый адрес);</li>
          <li>Данные, необходимые для реализации отдельных услуг (например, данные транспортного средства при регистрации, данные документов для легализации пребывания).</li>
        </ul>
        
        <h2>3. Правовая основа обработки данных</h2>
        <p>
          Персональные данные обрабатываются на основании:
        </p>
        <ul>
          <li>Необходимости для выполнения договора или принятия мер перед заключением договора (статья 6(1)(b) GDPR);</li>
          <li>Юридического обязательства Администратора (статья 6(1)(c) GDPR);</li>
          <li>Законного интереса Администратора (статья 6(1)(f) GDPR);</li>
          <li>Согласия субъекта данных (статья 6(1)(a) GDPR).</li>
        </ul>
        
        <h2>4. Период хранения данных</h2>
        <p>
          Мы храним персональные данные в течение периода:
        </p>
        <ul>
          <li>Необходимого для реализации услуги и в течение времени, предусмотренного законодательством (например, налоговые и бухгалтерские правила);</li>
          <li>До истечения срока давности претензий, вытекающих из заключенного соглашения;</li>
          <li>До отзыва согласия, если обработка основана на нем.</li>
        </ul>
        
        <h2>5. Получатели данных</h2>
        <p>
          Получателями персональных данных могут быть:
        </p>
        <ul>
          <li>Субъекты, обрабатывающие данные от имени Администратора (например, поставщики ИТ-услуг, бухгалтерские офисы);</li>
          <li>Субъекты, уполномоченные получать данные на основании действующего законодательства (например, суды, правоохранительные органы);</li>
          <li>Государственные учреждения и институты, необходимые для реализации услуг (например, городские офисы, налоговые офисы).</li>
        </ul>
        
        <h2>6. Права субъектов данных</h2>
        <p>
          Субъекты данных имеют следующие права:
        </p>
        <ul>
          <li>Право доступа к своим данным и получения их копии;</li>
          <li>Право на исправление (корректировку) своих данных;</li>
          <li>Право на удаление данных (так называемое "право быть забытым");</li>
          <li>Право на ограничение обработки данных;</li>
          <li>Право на перенос данных;</li>
          <li>Право на возражение против обработки;</li>
          <li>Право отозвать согласие в любой момент (без влияния на законность обработки, осуществленной на основании согласия до его отзыва);</li>
          <li>Право подать жалобу в надзорный орган (Председатель Управления защиты персональных данных).</li>
        </ul>
        
        <h2>7. Безопасность данных</h2>
        <p>
          Администратор применяет соответствующие технические и организационные меры, обеспечивающие безопасность обрабатываемых персональных данных, в частности защищающие данные от несанкционированного раскрытия, захвата неуполномоченным лицом, утраты, повреждения или уничтожения.
        </p>
        
        <h2>8. Cookies</h2>
        <p>
          Наш веб-сайт использует файлы cookies, которые служат для идентификации браузера при использовании нашего сайта. Cookies содержат небольшие объемы текста и не содержат персональных данных. Они могут быть удалены в любой момент с помощью настроек браузера.
        </p>
        
        <h2>9. Изменения Политики конфиденциальности</h2>
        <p>
          Администратор оставляет за собой право изменять Политику конфиденциальности. Пользователи будут уведомлены о любых изменениях через публикацию обновленной версии на веб-сайте.
        </p>
        
        <h2>10. Контакт</h2>
        <p>
          По всем вопросам, связанным с обработкой персональных данных, в том числе для реализации прав, указанных в пункте 6, просим обращаться:
        </p>
        <ul>
          <li>Email: kontakt1group.pl@gmail.com</li>
          <li>Телефон: +48 886 695 593</li>
          <li>Адрес: ул. Стары Рынек 61/2, 61-772 Познань</li>
        </ul>
      </>
    )
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Page Header */}
      <div className="bg-muted/30 py-12 md:py-16">
        <div className="container">
          <BackButton className="mb-4" />
          <h1 className="text-3xl md:text-4xl font-bold mb-4">{getTranslation("privacyPolicyTitle", language)}</h1>
          <p className="text-lg text-muted-foreground max-w-3xl">
            {getTranslation("privacyPolicyDescription", language)}
          </p>
        </div>
      </div>
      
      {/* Policy Content */}
      <div className="container py-12">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-blue dark:prose-invert max-w-none">
            {privacyContent[language]}
            
            <p className="text-sm text-muted-foreground mt-10">
              {getTranslation("privacyLastUpdate", language)} 20.09.2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}